import { createFileRoute } from "@tanstack/react-router";
import { ExFactoryPriceFormPage } from "@/features/contracts/exfactory-price-form-page";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/kontrakty/cenniki-exfactory/nowy")({
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(context.queryClient, "sidebar.kontrakty.nowy", location.pathname);
	},
	component: ExFactoryPriceFormPage,
});
